module.exports = __webpack_public_path__ + "assets/c6e3a0d4c6c21bf8f8ff46b598053856.mp4";